import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface ScoreTrendChartProps {
  data: Array<{
    date: string;
    avgScore: number;
    count: number;
  }>;
}

export const ScoreTrendChart: React.FC<ScoreTrendChartProps> = ({ data }) => {
  const formattedData = data.map((item) => ({
    ...item,
    month: new Date(item.date + '-01').toLocaleDateString('es-ES', {
      month: 'short',
      year: 'numeric',
    }),
  }));

  return (
    <div className="bg-white p-3 sm:p-4 md:p-6 rounded-lg shadow-sm">
      <h3 className="text-base sm:text-lg md:text-xl font-semibold mb-3 sm:mb-4 text-gray-800">
        Tendencia de Calificaciones
      </h3>
      <div className="w-full h-64 sm:h-80 lg:h-96">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={formattedData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" style={{ fontSize: '12px' }} />
            <YAxis domain={[0, 100]} style={{ fontSize: '12px' }} />
            <Tooltip
              formatter={(value: number, name: string) => {
                if (name === 'avgScore')
                  return [`${value.toFixed(1)}%`, 'Promedio'];
                return [value, 'Reportes'];
              }}
            />
            <Legend />
            <Line
              type="monotone"
              dataKey="avgScore"
              stroke="#3b82f6"
              strokeWidth={2}
              name="Promedio"
              dot={{ fill: '#3b82f6', r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
